import React, { useState } from "react";

function PasswordInput({ className = "form-control", id, style, ...rest }) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <input
        {...rest}
        id={id}
        type={show ? "text" : "password"}
        className={className}
        style={{ paddingRight: "2.5rem", ...style }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          top: "50%",
          right: "0.65rem",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          color: "#6c757d",
          lineHeight: 1,
        }}
      >
        <i
          className={show ? "bi bi-eye-slash" : "bi bi-eye"}
          aria-hidden="true"
        />
      </button>
    </div>
  );
}

export default PasswordInput;
